import { forwardRef } from 'react';

export const SuccessIcon = forwardRef<SVGSVGElement, React.HTMLAttributes<SVGSVGElement>>(
  function Icon(props, ref) {
    return (
      <svg ref={ref} viewBox="0 0 88 85" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path
          d="M75.0998 40.5004C75.1998 41.6004 75.2998 42.7004 75.2998 43.9004C75.2998 62.7004 60.0998 77.9004 41.2998 77.9004C22.4998 77.9004 7.2998 62.7004 7.2998 43.9004C7.2998 25.1004 22.4998 9.90039 41.2998 9.90039C49.9998 9.90039 57.9998 13.2004 63.9998 18.7004"
          strokeMiterlimit="10"
          stroke="currentColor"
          strokeLinecap="round"
          fill="none"
        />
        <path
          d="M57.7999 25.4002L41.5999 42.4002L30.3999 32.8002C28.7999 31.5002 26.5999 31.3002 24.7999 32.5002C22.4999 34.0002 21.9999 37.0002 23.3999 39.2002L36.1999 58.8002C36.5999 59.5002 37.1999 60.1002 37.8999 60.6002C41.0999 63.0002 45.4999 62.3002 47.7999 59.0002L48.0999 58.6002L79.9999 13.3002C81.0999 11.7002 80.9999 9.6002 79.5999 8.2002C78.0999 6.7002 75.6999 6.7002 74.1999 8.2002L66.1999 16.6002L64.1999 18.8002"
          strokeMiterlimit="10"
          stroke="currentColor"
          strokeLinecap="round"
          fill="none"
        />
      </svg>
    );
  },
);
